export enum EPersonalDetailsFormSteps {
  firstStep = 'firstStep',
  secondStep = 'secondStep',
  thirdStep = 'thirdStep',
  mhfcId = 'mhfcId',
  personalInfo = 'personalInfo',
  extraPersonalInfo = 'extraPersonalInfo',
  last = 'last',
}
